import * as T from 'components/ui/typography'

interface PropsTitlePage {
    title: string
    subtitle: string
    paddingLeft?: number
}

export default function TitlePage(props: PropsTitlePage) {
    return (
        <div className={`sm:${props.paddingLeft ? `pl-[${props.paddingLeft * 5}px]` : 'pl-[30px]'}`}>
            <T.H1 className="pt-2 lg:text-3xl">{props.title}</T.H1>
            <T.P className="max-w-[700px] font-regular !mt-1 text-neutral-500">{props.subtitle}</T.P>
        </div>
    )
}
